export const formatDuration = (seconds: number | null): string | null => {
  if (seconds === null) {
    return null
  }

  if (seconds < 60) {
    return `${seconds}s`
  }

  const minutes = Math.floor(seconds / 60)
  const remainder = seconds % 60

  return `${minutes}:${remainder.toString().padStart(2, '0')}`
}
